document.addEventListener(
  "cart:updated",
  function (e) {
    if (
      e &&
      e.detail &&
      e.detail.cart &&
      e.detail.cart.items &&
      e.detail.cart.items.length > 0
    ) {
      let product = [];
      e.detail.cart.items.forEach((item, index) => {
        product.push({ id: item.product_id, quantity: item.quantity });
      });
      var list = document.getElementsByClassName("greenstory")[0];
      // Greenstory cart widget container isn't on every page/layout
      if (!list) return;
      list.innerHTML = `<gs-cart widgettype="cart" clientid="pJDI3wmBdbehgBYOVEzs1FIJOUkYt9fN" productList=${JSON.stringify(
        product
      )}></gs-cart>`;
    }
  },
  false
);

document.addEventListener(
  "ajaxProduct:added",
  function (e) {
    console.log("product added", e.detail.product);
    if (
      e &&
      e.detail &&
      e.detail.product &&
      e.detail.product.product_id &&
      e.detail.product.quantity
    ) {
      let product = [];

      product.push({
        id: e.detail.product.product_id,
        quantity: e.detail.product.quantity,
      });

      var list = document.getElementsByClassName("greenstory")[0];
      // Greenstory cart widget container isn't on every page/layout
      if (!list) return;
      list.innerHTML = `<gs-cart widgettype="cart" clientid="pJDI3wmBdbehgBYOVEzs1FIJOUkYt9fN" productList=${JSON.stringify(
        product
      )}></gs-cart>`;
    }
  },
  false
);
